/* global jQuery COMPONENTS */

COMPONENTS.ComponentCards = (function ($) {
  function ComponentCards () {
    this.utility = new COMPONENTS.Utility()
    this.$cardComponents = $('[data-ecs-component-container="component-cards"]')

    this.calcFlipHeight = function (_component, $card) {
      const cardPadding = $($card).innerHeight() - $($card).height()
      const frontContent = $card.find('[data-ecs-card-side="front"]')
      const backContent = $card.find('[data-ecs-card-side="back"]')

      if (frontContent.outerHeight() > backContent.innerHeight()) {
        $card.css('min-height', (frontContent.innerHeight() + cardPadding) + 'px')
      } else {
        $card.css('min-height', (backContent.innerHeight() + cardPadding) + 'px')
      }

      $card.click(function () {
        if ($(this).hasClass('ecs_active')) {
          // Remove active class from all flip cards
          _component.$flipCards.each(function () {
            $(this).removeClass('ecs_active')
          })
        } else {
          // Remove active class from all flip cards
          _component.$flipCards.each(function () {
            $(this).removeClass('ecs_active')
          })
          $(this).addClass('ecs_active')
        }
        $(this).toggleClass('ecs_active')
      })
    }
  }

  ComponentCards.prototype.init = function () {
    const component = this

    component.$cardComponents.each(function () {
      const $component = $(this)
      const utility = new COMPONENTS.Utility()
      $component.index = $component.data('ecs-content-index')
      $component.template = $component.attr('data-ecs-template')
      $component.$cardsSlider = $component.find('[data-ecs-component-control="cards-slider"]')
      $component.slideCount = ($component.$cardsSlider.attr('ecs-components-slide-count') ? $component.$cardsSlider.attr('ecs-components-slide-count') : 1)
      $component.$cardSlider = $component.find('[data-ecs-component-control="card-slider"]')
      $component.$flipCards = $component.find('[data-ecs-card-type="flip"]')
      $component.$cardGallery = $component.find('[data-ecs-element="card-gallery"]')
      $component.$cardGallery.active = $component.$cardGallery.attr('data-ecs-gallery')

      if ($component.$flipCards.length >= 1) {
        $component.$flipCards.each(function () {
          component.calcFlipHeight($component, $(this))
        })
      }

      $component.sliderVars = {
        cardSlider: utility.getSliderVars(),
        cardsSlider: utility.getSliderVars($component.slideCount, false)
      }

      if ($component.$cardSlider.length >= 1) {
        $component.$cardSlider.slick($component.sliderVars.cardSlider)
        utility.bindSliderAriaSelected($component.$cardSlider)
      }

      $component.$cardsSlider.slick($component.sliderVars.cardsSlider)
      utility.bindSliderAriaSelected($component.$cardsSlider)

      if ($component.$cardGallery.length >= 1 && $component.$cardGallery.active == true) {
        $component.$cardGallery.imagesLoaded(function () {
          $component.$cardGallery.isotope()
          $component.$cardGallery.on('arrangeComplete', function () {
            COMPONENTS.equalUtility.height()
          })
        })
      }

      $(window).on('orientationchange', function () {
        // Recalc heights when the device rotates
        $($component.$flipCards).each(function () {
          component.calcFlipHeight($(this))
        })
      })

      $(window).on('resize', function () {
        // Recalc heights when the viewport size changes
        $($component.$flipCards).each(function () {
          component.calcFlipHeight($(this))
        })
      })
    })
  }

  return ComponentCards
})(jQuery)

document.addEventListener('components_init', function () {
  // Hook into the main components init
  COMPONENTS.componentCards = new COMPONENTS.ComponentCards()
  COMPONENTS.componentCards.init()
})
